/**
 * Important: These regular expressions must match the ones defined in the backend
 */
export class RegexExpressions {
    public static readonly UserName: RegExp = new RegExp (/^[a-zA-Z0-9_-]+$/);
    public static readonly Email: RegExp = new RegExp (/^(([^<>()[\]\\.,;:\s@""]+(\.[^<>()[\]\\.,;:\s@""]+)*)|("".+""))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    public static readonly NoSpaces: RegExp = new RegExp (/^\d+$/);
    public static readonly Password: RegExp = new RegExp (/^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{10,100}$/); // Note: Must match min and max in validation.constants.ts
    public static readonly LinkValidatorPattern: RegExp = new RegExp (/^(http|https):\/\/([\w-]+.)+[\w-]+(\/[\w- .\/?%&=]*)?$/);
    public static readonly TenDigitString: RegExp = new RegExp (/^\d{10}$/);
}
